import axios from '../utils/AxiosInstance'

export default {
  // namespaced: true,
  state: {
    sources: {
      selectIds: [],
      filters: {},
      paginate: {},
      selectId: false
    }
  },
  mutations: {
    SET_SOURCE_SELECT_IDS (store, ids) {
      store.sources.selectIds = ids
    },
    REMOVE_SOURCE_SELECT_IDS (store, ids) {
      store.sources.selectIds = store.sources.selectIds.filter((v) => { return !ids.includes(v) })
    },
    SET_SOURCE_SELECT_ID (store, id) {
      store.sources.selectId = id
    },
    SET_SOURCE_FILTERS (store, filters) {
      store.sources.filters = filters
    },
    SET_SOURCE_PAGINATE (store, val) {
      store.sources.paginate = {
        limit: val.limit,
        page: val.page,
        pages: val.pages,
        total: val.total
      }
    }
  },
  getters: {
    getSources: (store, getters) => {
      return store.sources.selectIds.map((id) => {
        return getters['entities/sources/find'](id)
      })
    },
    getSourcesFilters: (store, getters) => {
      return store.sources.filters
    },
    getSourcesPaginate: (store, getters) => {
      return store.sources.paginate
    },
    getSource: (store, getters) => {
      return getters['entities/sources/find'](store.sources.selectId) || {}
    }
  },
  actions: {
    /*
    selectSources
    */
    selectSources ({commit, dispatch, getters, state}, filters) {
      return dispatch('getSources', filters)
      .then((response) => {
        commit('SET_SOURCE_FILTERS', filters)
        commit('SET_SOURCE_PAGINATE', response)
        commit('SET_SOURCE_SELECT_IDS', response.docs.map((item) => { return item._id }))
        return response
      })
    },
    /*
    refreshSelectSources
    */
    refreshSelectSources ({commit, dispatch, getters, state}) {
      return dispatch('selectSources', getters.getSourcesFilters)
    },
    /*
    selectSource
    */
    selectSource ({commit, dispatch, getters, state}, id) {
      return dispatch('getSourceById', id)
      .then((response) => {
        commit('SET_SOURCE_SELECT_ID', response._id)
        return response
      })
    },
    /*
    getSources
    */
    getSources ({commit, dispatch, getters, state}, filters) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/sources`, {params: filters})
      .then((response) => {
        return dispatch('entities/sources/insert', {
          data: response.data.docs
        })
        .then((result) => {
          return {
            docs: result.sources || [],
            limit: response.data.limit,
            page: response.data.page,
            pages: response.data.pages,
            total: response.data.total
          }
        })
      })
    },
    /*
    getSourceById
    */
    getSourceById ({commit, dispatch, getters, state}, id) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/sources/${id}`)
      .then((response) => {
        return dispatch('entities/sources/insert', {
          data: response.data
        })
      })
      .then((result) => {
        return result.sources[0]
      })
    },
    /*
    createSource
    */
    createSource ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .post(`/accounts/${getters.getAccount._id}/sources`, data)
      .then((response) => {
        return dispatch('entities/sources/insert', {
          data: response.data
        })
      })
      .then((response) => {
        return response.sources[0]
      })
    },
    /*
    updateSource
    */
    updateSource ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .put(`/accounts/${getters.getAccount._id}/sources/${data._id}`, data)
      .then((response) => {
        return dispatch('entities/sources/insert', {
          data: response.data
        })
      })
      .then((response) => {
        return response.sources[0]
      })
    },
    /*
    mergeSources
    */
    mergeSources ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .put(`/accounts/${getters.getAccount._id}/sources/merge`, data)
      .then((response) => {
        return dispatch('entities/sources/insert', {
          data: response.data
        })
      })
      .then((response) => {
        return response.sources[0]
      })
    },
    /*
    deleteSource
    */
    deleteSource ({commit, dispatch, getters, state}, id) {
      return axios
      .delete(`/accounts/${getters.getAccount._id}/sources/${id}`)
      .then((response) => {
        commit('REMOVE_SOURCE_SELECT_IDS', [id])
        dispatch('entities/sources/delete', id)
        return {}
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/Source.js